import React, { createContext, useState, useContext } from 'react';

const LanguageContext = createContext();

const translations = {
  fr: {
    // Navbar
    home: 'Accueil',
    leaderboard: 'Classement',
    login: 'Connexion',
    
    // Home
    heroTitle1: 'Gagne ta part des',
    heroTitle2: 'mensuels',
    heroDesc: 'Rejoins la communauté EliteBet, mise sur Roobet.com avec le code "fastbonus" et participe à nos races bi-weekly de $7,500 !',
    joinRoobet: 'Rejoindre Roobet',
    viewLeaderboard: 'Voir le classement',
    
    // Offers
    offer1Title: '50$ Offert',
    offer1Subtitle: 'Après 2000$ de wager',
    offer1Line1: 'Inscris-toi avec le code',
    offer1Line2: 'Wager',
    offer1Line3: 'Contacte-nous sur',
    
    offer2Title: 'Classement mensuel',
    offer2Subtitle: '$15,000 à gagner',
    offer2Line1: 'Inscris-toi avec le code',
    offer2Line2: 'Mise sur',
    offer2Line2b: 'avec nous',
    offer2Line3: 'Consulte le',
    offer2Line3b: 'classement en temps réel',
    
    offer3Title: 'Code drop & Free spins',
    offer3Subtitle: 'Offerts régulièrement',
    offer3Line1: 'Inscris-toi avec le code',
    offer3Line2: 'Des centaines de',
    offer3Line2b: 'codes Roobet',
    offer3Line2c: 'à gagner',
    offer3Line3: 'Des centaines de',
    offer3Line3b: 'free spins',
    offer3Line3c: 'à gagner',
    
    joinDiscord: 'Rejoindre le Discord',
    discordCta: 'Rejoins notre',
    discordCtaEnd: 'pour ne rien manquer !',
    
    // Leaderboard
    raceBiWeekly: 'RACE BI-WEEKLY',
    current: 'Classement actuel',
    previous: 'Classement précédent',
    rank: 'RANG',
    player: 'JOUEUR',
    wagered: 'MISÉ',
    prize: 'GAIN',
    notPaid: 'NON PAYÉ',
    days: 'Jours',
    hours: 'Heures',
    minutes: 'Min',
    seconds: 'Sec',
    loading: 'Chargement...',
    
    // Profile
    myPoints: 'Mes Points',
    availableRewards: 'Récompenses disponibles',
    memberSince: 'Membre depuis le',
    logout: 'Déconnexion',
    claim: 'Réclamer',
    
    // Rewards
    reward1: '$10 Dépôt Offert',
    reward2: '$25 Dépôt Offert',
    reward3: '$50 Dépôt Offert',
    points: 'points',
    
    // Claim Modal
    claimTitle: 'Réclamer',
    claimCasinoLabel: 'Entrez votre pseudo casino',
    claimCasinoPlaceholder: 'Ex: MonPseudoRoobet',
    claimHint: 'Ce pseudo sera utilisé pour vous envoyer votre récompense.',
    claimCancel: 'Annuler',
    claimConfirm: 'Confirmer',
    claimSending: 'Envoi...',
    claimSuccess: 'Demande envoyée ! Vous recevrez votre récompense sous peu.',
    claimErrorUsername: 'Veuillez entrer votre pseudo casino',
    claimErrorConnection: 'Erreur de connexion',
    
    // Login
    loginTitle: 'Connexion',
    loginSubtitle: 'Connecte-toi pour accéder à ton compte',
    continueWithDiscord: 'Continuer avec Discord',
    continueWithGoogle: 'Continuer avec Google',
    
    // Banner
    bannerText: 'Dépot de 50$ Offert - clique ici !',
    
    // Race
    race: 'Race',
  },
  en: {
    // Navbar
    home: 'Home',
    leaderboard: 'Leaderboard',
    login: 'Login',
    
    // Home
    heroTitle1: 'Win your share of',
    heroTitle2: 'monthly',
    heroDesc: 'Join the EliteBet community, bet on Roobet.com with code "fastbonus" and participate in our bi-weekly $7,500 races!',
    joinRoobet: 'Join Roobet',
    viewLeaderboard: 'View leaderboard',
    
    // Offers
    offer1Title: '$50 Free',
    offer1Subtitle: 'After $2000 wagered',
    offer1Line1: 'Sign up with code',
    offer1Line2: 'Wager',
    offer1Line3: 'Contact us on',
    
    offer2Title: 'Monthly leaderboard',
    offer2Subtitle: '$15,000 to win',
    offer2Line1: 'Sign up with code',
    offer2Line2: 'Bet on',
    offer2Line2b: 'with us',
    offer2Line3: 'Check the',
    offer2Line3b: 'live leaderboard',
    
    offer3Title: 'Code drops & Free spins',
    offer3Subtitle: 'Offered regularly',
    offer3Line1: 'Sign up with code',
    offer3Line2: 'Hundreds of',
    offer3Line2b: 'Roobet codes',
    offer3Line2c: 'to win',
    offer3Line3: 'Hundreds of',
    offer3Line3b: 'free spins',
    offer3Line3c: 'to win',
    
    joinDiscord: 'Join Discord',
    discordCta: 'Join our',
    discordCtaEnd: 'to never miss anything!',
    
    // Leaderboard
    raceBiWeekly: 'BI-WEEKLY RACE',
    current: 'Current leaderboard',
    previous: 'Previous leaderboard',
    rank: 'RANK',
    player: 'PLAYER',
    wagered: 'WAGERED',
    prize: 'PRIZE',
    notPaid: 'NOT PAID',
    days: 'Days',
    hours: 'Hours',
    minutes: 'Min',
    seconds: 'Sec',
    loading: 'Loading...',
    
    // Profile
    myPoints: 'My Points',
    availableRewards: 'Available rewards',
    memberSince: 'Member since',
    logout: 'Logout',
    claim: 'Claim',
    
    // Rewards
    reward1: '$10 Free Deposit',
    reward2: '$25 Free Deposit',
    reward3: '$50 Free Deposit',
    points: 'points',
    
    // Claim Modal
    claimTitle: 'Claim',
    claimCasinoLabel: 'Enter your casino username',
    claimCasinoPlaceholder: 'Ex: MyRoobetUsername',
    claimHint: 'This username will be used to send you your reward.',
    claimCancel: 'Cancel',
    claimConfirm: 'Confirm',
    claimSending: 'Sending...',
    claimSuccess: 'Request sent! You will receive your reward shortly.',
    claimErrorUsername: 'Please enter your casino username',
    claimErrorConnection: 'Connection error',
    
    // Login
    loginTitle: 'Login',
    loginSubtitle: 'Sign in to access your account',
    continueWithDiscord: 'Continue with Discord',
    continueWithGoogle: 'Continue with Google',
    
    // Banner
    bannerText: '$50 Deposit Free - click here!',
    
    // Race
    race: 'Race',
  },
  es: {
    // Navbar
    home: 'Inicio',
    leaderboard: 'Clasificación',
    login: 'Iniciar sesión',
    
    // Home
    heroTitle1: 'Gana tu parte de los',
    heroTitle2: 'mensuales',
    heroDesc: '¡Únete a la comunidad EliteBet, apuesta en Roobet.com con el código "fastbonus" y participa en nuestras carreras bi-semanales de $7,500!',
    joinRoobet: 'Unirse a Roobet',
    viewLeaderboard: 'Ver clasificación',
    
    // Offers
    offer1Title: '$50 Gratis',
    offer1Subtitle: 'Después de $2000 apostados',
    offer1Line1: 'Regístrate con el código',
    offer1Line2: 'Apuesta',
    offer1Line3: 'Contáctanos en',
    
    offer2Title: 'Clasificación mensual',
    offer2Subtitle: '$15,000 para ganar',
    offer2Line1: 'Regístrate con el código',
    offer2Line2: 'Apuesta en',
    offer2Line2b: 'con nosotros',
    offer2Line3: 'Consulta la',
    offer2Line3b: 'clasificación en vivo',
    
    offer3Title: 'Códigos y giros gratis',
    offer3Subtitle: 'Ofrecidos regularmente',
    offer3Line1: 'Regístrate con el código',
    offer3Line2: 'Cientos de',
    offer3Line2b: 'códigos Roobet',
    offer3Line2c: 'para ganar',
    offer3Line3: 'Cientos de',
    offer3Line3b: 'giros gratis',
    offer3Line3c: 'para ganar',
    
    joinDiscord: 'Unirse a Discord',
    discordCta: 'Únete a nuestro',
    discordCtaEnd: '¡para no perderte nada!',
    
    // Leaderboard
    raceBiWeekly: 'CARRERA BI-SEMANAL',
    current: 'Clasificación actual',
    previous: 'Clasificación anterior',
    rank: 'RANGO',
    player: 'JUGADOR',
    wagered: 'APOSTADO',
    prize: 'PREMIO',
    notPaid: 'NO PAGADO',
    days: 'Días',
    hours: 'Horas',
    minutes: 'Min',
    seconds: 'Seg',
    loading: 'Cargando...',
    
    // Profile
    myPoints: 'Mis Puntos',
    availableRewards: 'Recompensas disponibles',
    memberSince: 'Miembro desde',
    logout: 'Cerrar sesión',
    claim: 'Reclamar',
    
    // Rewards
    reward1: '$10 Depósito Gratis',
    reward2: '$25 Depósito Gratis',
    reward3: '$50 Depósito Gratis',
    points: 'puntos',
    
    // Claim Modal
    claimTitle: 'Reclamar',
    claimCasinoLabel: 'Ingresa tu usuario del casino',
    claimCasinoPlaceholder: 'Ej: MiUsuarioRoobet',
    claimHint: 'Este usuario se usará para enviarte tu recompensa.',
    claimCancel: 'Cancelar',
    claimConfirm: 'Confirmar',
    claimSending: 'Enviando...',
    claimSuccess: '¡Solicitud enviada! Recibirás tu recompensa pronto.',
    claimErrorUsername: 'Por favor ingresa tu usuario del casino',
    claimErrorConnection: 'Error de conexión',
    
    // Login
    loginTitle: 'Iniciar sesión',
    loginSubtitle: 'Inicia sesión para acceder a tu cuenta',
    continueWithDiscord: 'Continuar con Discord',
    continueWithGoogle: 'Continuar con Google',
    
    // Banner
    bannerText: '¡$50 de Depósito Gratis - clic aquí!',
    
    // Race
    race: 'Carrera',
  },
  pt: {
    // Navbar
    home: 'Início',
    leaderboard: 'Classificação',
    login: 'Entrar',
    
    // Home
    heroTitle1: 'Ganhe sua parte dos',
    heroTitle2: 'mensais',
    heroDesc: 'Junte-se à comunidade EliteBet, aposte no Roobet.com com o código "fastbonus" e participe das nossas corridas bi-semanais de $7,500!',
    joinRoobet: 'Entrar no Roobet',
    viewLeaderboard: 'Ver classificação',
    
    // Offers
    offer1Title: '$50 Grátis',
    offer1Subtitle: 'Após $2000 apostados',
    offer1Line1: 'Cadastre-se com o código',
    offer1Line2: 'Aposte',
    offer1Line3: 'Contate-nos no',
    
    offer2Title: 'Classificação mensal',
    offer2Subtitle: '$15,000 para ganhar',
    offer2Line1: 'Cadastre-se com o código',
    offer2Line2: 'Aposte no',
    offer2Line2b: 'conosco',
    offer2Line3: 'Confira a',
    offer2Line3b: 'classificação ao vivo',
    
    offer3Title: 'Códigos e giros grátis',
    offer3Subtitle: 'Oferecidos regularmente',
    offer3Line1: 'Cadastre-se com o código',
    offer3Line2: 'Centenas de',
    offer3Line2b: 'códigos Roobet',
    offer3Line2c: 'para ganhar',
    offer3Line3: 'Centenas de',
    offer3Line3b: 'giros grátis',
    offer3Line3c: 'para ganhar',
    
    joinDiscord: 'Entrar no Discord',
    discordCta: 'Junte-se ao nosso',
    discordCtaEnd: 'para não perder nada!',
    
    // Leaderboard
    raceBiWeekly: 'CORRIDA BI-SEMANAL',
    current: 'Classificação atual',
    previous: 'Classificação anterior',
    rank: 'POSIÇÃO',
    player: 'JOGADOR',
    wagered: 'APOSTADO',
    prize: 'PRÊMIO',
    notPaid: 'NÃO PAGO',
    days: 'Dias',
    hours: 'Horas',
    minutes: 'Min',
    seconds: 'Seg',
    loading: 'Carregando...',
    
    // Profile
    myPoints: 'Meus Pontos',
    availableRewards: 'Recompensas disponíveis',
    memberSince: 'Membro desde',
    logout: 'Sair',
    claim: 'Resgatar',
    
    // Rewards
    reward1: '$10 Depósito Grátis',
    reward2: '$25 Depósito Grátis',
    reward3: '$50 Depósito Grátis',
    points: 'pontos',
    
    // Claim Modal
    claimTitle: 'Resgatar',
    claimCasinoLabel: 'Digite seu usuário do casino',
    claimCasinoPlaceholder: 'Ex: MeuUsuarioRoobet',
    claimHint: 'Este usuário será usado para enviar sua recompensa.',
    claimCancel: 'Cancelar',
    claimConfirm: 'Confirmar',
    claimSending: 'Enviando...',
    claimSuccess: 'Solicitação enviada! Você receberá sua recompensa em breve.',
    claimErrorUsername: 'Por favor digite seu usuário do casino',
    claimErrorConnection: 'Erro de conexão',
    
    // Login
    loginTitle: 'Entrar',
    loginSubtitle: 'Entre para acessar sua conta',
    continueWithDiscord: 'Continuar com Discord',
    continueWithGoogle: 'Continuar com Google',
    
    // Banner
    bannerText: '$50 de Depósito Grátis - clique aqui!',
    
    // Race
    race: 'Corrida',
  }
};

const flags = {
  fr: '🇫🇷',
  en: '🇬🇧',
  es: '🇪🇸',
  pt: '🇧🇷'
};

const langNames = {
  fr: 'Français',
  en: 'English',
  es: 'Español',
  pt: 'Português'
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('fr');

  const t = (key) => {
    return translations[lang]?.[key] || translations['en']?.[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, flags, langNames }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
